export default "__VITE_ASSET__e5742415__"